import { useState } from "react";
import { KeyRound } from "lucide-react";
import { platformClient, formatPlatformError, isPasswordStrong, PASSWORD_POLICY_MSG } from "@/pages/platform/platformApi";
import { PasswordInput } from "@/components/ui/PasswordInput";

export const ChangePassword = () => {
    const [open, setOpen] = useState(false);
    const [form, setForm] = useState({ current: "", next: "" });
    const [msg, setMsg] = useState("");
    const [err, setErr] = useState("");
    const [busy, setBusy] = useState(false);

    const submit = async (e) => {
        e.preventDefault();
        if (!isPasswordStrong(form.next)) {
            setErr(PASSWORD_POLICY_MSG);
            return;
        }
        setBusy(true);
        setErr("");
        setMsg("");
        try {
            await platformClient.post("/auth/change-password", {
                current_password: form.current,
                new_password: form.next,
            });
            setMsg("Wachtwoord gewijzigd.");
            setForm({ current: "", next: "" });
        } catch (error) {
            setErr(formatPlatformError(error.response?.data?.detail));
        } finally {
            setBusy(false);
        }
    };

    return (
        <div className="relative">
            <button
                data-testid="change-password-toggle"
                onClick={() => {
                    setOpen(!open);
                    setMsg("");
                    setErr("");
                }}
                aria-label="Wachtwoord wijzigen"
                className="flex items-center gap-2 border border-white/15 px-4 py-2.5 text-xs uppercase tracking-[0.2em] text-ash transition-colors hover:border-gold/60 hover:text-gold"
            >
                <KeyRound className="h-3.5 w-3.5" />
                <span className="hidden sm:inline">Wachtwoord</span>
            </button>
            {open ? (
                <div
                    data-testid="change-password-panel"
                    className="absolute right-0 z-30 mt-2 w-80 border border-white/10 bg-coal p-6 shadow-2xl"
                >
                    <p className="text-[11px] uppercase tracking-[0.25em] text-ash">
                        Wachtwoord wijzigen
                    </p>
                    <form onSubmit={submit} className="mt-5 space-y-5">
                        <PasswordInput
                            testid="change-password-current"
                            value={form.current}
                            onChange={(e) => setForm({ ...form, current: e.target.value })}
                            className="w-full border-b border-white/20 bg-transparent pb-2.5 text-sm text-bone placeholder:text-ash/50 transition-colors focus:border-gold focus:outline-none"
                        />
                        <div>
                            <PasswordInput
                                testid="change-password-new"
                                value={form.next}
                                onChange={(e) => setForm({ ...form, next: e.target.value })}
                                autoComplete="new-password"
                                className="w-full border-b border-white/20 bg-transparent pb-2.5 text-sm text-bone placeholder:text-ash/50 transition-colors focus:border-gold focus:outline-none"
                            />
                            <p className="mt-2 text-[10px] uppercase tracking-[0.15em] text-ash/60">
                                Huidig wachtwoord · nieuw wachtwoord (min. 10 tekens, hoofdletter, kleine letter en cijfer)
                            </p>
                        </div>
                        {err ? (
                            <p data-testid="change-password-error" className="text-sm text-red-400">
                                {err}
                            </p>
                        ) : null}
                        {msg ? (
                            <p data-testid="change-password-success" className="text-sm text-gold">
                                {msg}
                            </p>
                        ) : null}
                        <button
                            data-testid="change-password-submit"
                            type="submit"
                            disabled={busy}
                            className="w-full bg-gold px-5 py-3 text-xs uppercase tracking-[0.2em] text-black transition-colors hover:bg-bone disabled:opacity-60"
                        >
                            {busy ? "Opslaan…" : "Opslaan"}
                        </button>
                    </form>
                </div>
            ) : null}
        </div>
    );
};
